import packageJson from "./package.json";

const { version } = packageJson;

export default version;
